const getUnreadChatsCount = (contacts, chats) => {
  const unreadContactMessages = contacts.reduce((acc, cur) => {
    if (!cur.messages || !cur.messages.unread) return acc;
    return acc + 1;
  }, 0);
  const unreadChatMessages = chats.reduce((acc, cur) => {
    if (!cur.messagesUnreadCount) return acc;
    return acc + 1;
  }, 0);
  return unreadContactMessages + unreadChatMessages;
};

export default getUnreadChatsCount;
